import React from 'react';
import { useAgents } from '../hooks/useAgents';
import AgentCard from '../components/AgentCard';

const SQUAD_DESCRIPTIONS = {
  'Estrategia': 'Planejamento estrategico, metricas e gestao de contas',
  'Criacao': 'Producao de conteudo, copy, roteiros e direcao criativa',
  'Social & Comunidade': 'Gestao de redes sociais e comunidade',
  'Trafego Pago': 'Gestao de anuncios e performance de midia',
  'Producao': 'Briefings criativos e coordenacao de producao',
};

const SQUAD_ICONS = {
  'Estrategia': '\uD83C\uDFAF',
  'Criacao': '\u270D\uFE0F',
  'Social & Comunidade': '\uD83D\uDCAC',
  'Trafego Pago': '\uD83D\uDCB0',
  'Producao': '\uD83D\uDCCB',
};

function Agents() {
  const { agentsBySquad, squadOrder, agents } = useAgents();

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Agentes</h1>
        <p className="page-subtitle">
          {agents.length} agentes organizados em {squadOrder.length} squads
        </p>
      </div>

      {squadOrder.map(squad => (
        <div key={squad} className="section">
          <h2 className="section-title">
            {SQUAD_ICONS[squad]} {squad}
            <span style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', fontWeight: 400, marginLeft: 'var(--spacing-sm)' }}>
              — {SQUAD_DESCRIPTIONS[squad]}
            </span>
          </h2>
          <div className="grid grid-3">
            {agentsBySquad[squad].map(agent => (
              <AgentCard key={agent.id} agent={agent} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Agents;
